// Users page — add / edit / delete / reset-password handlers.

(function ($) {
  'use strict';

  if ($('#user-tbody').length === 0) return;

  var BTN_PRIMARY = 'bg-orange-500 hover:bg-orange-600 text-white';
  var BTN_DANGER  = 'bg-red-500 hover:bg-red-600 text-white';

  function readForm() {
    return {
      username: $('#user-username').val().trim(),
      email: $('#user-email').val().trim(),
      full_name: $('#user-full_name').val().trim(),
      role_id: $('#user-role_id').val(),
      password: $('#user-password').val(),
      is_active: $('#user-is_active').is(':checked') ? 'on' : '',
    };
  }

  function patchRow($row, fields) {
    if (fields.username !== undefined)  $row.find('.row-username').text(fields.username);
    if (fields.email !== undefined)     $row.find('.row-email').text(fields.email);
    if (fields.full_name !== undefined) $row.find('.row-full_name').text(fields.full_name);
    if (fields.role !== undefined) {
      $row.find('.row-role span').text(fields.role);
    }
    if (fields.is_active !== undefined) {
      var $cell = $row.find('.row-is_active');
      var active = fields.is_active === 'Active';
      $cell.html(
        '<span class="inline-block px-2 py-0.5 rounded text-xs ' +
          (active
            ? 'bg-green-100 text-green-700 dark:bg-green-900/40 dark:text-green-300'
            : 'bg-red-100 text-red-700 dark:bg-red-900/40 dark:text-red-300') +
          '">' + (active ? 'Active' : 'Disabled') + '</span>'
      );
    }
  }

  // ---------- Add ----------
  $(document).on('click', '.user-add-btn', function () {
    $.get('/api/users/modal/add/', function (resp) {
      if (!resp.ok) { Toast.show(resp.error || 'Failed', 'error'); return; }
      var dlg = new Dialog('Add user', resp.html, { size: 'lg' });
      dlg.setButtons([
        { name: 'Cancel', dismiss: true },
        {
          name: 'Create',
          class: BTN_PRIMARY,
          onClick: function () {
            var lb = new LoadingButton(this); lb.start();
            $.post('/api/users/add/', readForm())
              .done(function (r) {
                if (r.ok) {
                  $('#user-tbody').prepend(r.row_html);
                  Toast.show('User created', 'success');
                  dlg.hide();
                } else { Toast.show(r.error || 'Failed', 'error'); lb.stop('Create'); }
              })
              .fail(function (xhr) {
                Toast.show((xhr.responseJSON && xhr.responseJSON.error) || 'Request failed', 'error');
                lb.stop('Create');
              });
          },
        },
      ]).show();
    });
  });

  // ---------- Edit ----------
  $(document).on('click', '.user-edit-btn', function () {
    var $row = $(this).closest('tr');
    var id = $row.data('id');
    $.get('/api/users/modal/update/', { id: id }, function (resp) {
      if (!resp.ok) { Toast.show(resp.error || 'Failed', 'error'); return; }
      var dlg = new Dialog('Edit user', resp.html, { size: 'lg' });
      dlg.setButtons([
        { name: 'Cancel', dismiss: true },
        {
          name: 'Save',
          class: BTN_PRIMARY,
          onClick: function () {
            var lb = new LoadingButton(this); lb.start();
            $.post('/api/users/' + id + '/update/', readForm())
              .done(function (r) {
                if (r.ok) {
                  patchRow($row, r.fields);
                  Toast.show('User updated', 'success');
                  dlg.hide();
                } else { Toast.show(r.error || 'Failed', 'error'); lb.stop('Save'); }
              })
              .fail(function (xhr) {
                Toast.show((xhr.responseJSON && xhr.responseJSON.error) || 'Request failed', 'error');
                lb.stop('Save');
              });
          },
        },
      ]).show();
    });
  });

  // ---------- Delete ----------
  $(document).on('click', '.user-delete-btn', function () {
    var $row = $(this).closest('tr');
    var id = $row.data('id');
    $.get('/api/users/modal/delete/', { id: id }, function (resp) {
      if (!resp.ok) { Toast.show(resp.error || 'Failed', 'error'); return; }
      var dlg = new Dialog('Delete user', resp.html, { size: 'sm' });
      dlg.setButtons([
        { name: 'Cancel', dismiss: true },
        {
          name: 'Delete',
          class: BTN_DANGER,
          onClick: function () {
            var lb = new LoadingButton(this); lb.start();
            $.post('/api/users/' + id + '/delete/')
              .done(function (r) {
                if (r.ok) {
                  $row.remove();
                  Toast.show('User deleted', 'success');
                  dlg.hide();
                } else { Toast.show(r.error || 'Failed', 'error'); lb.stop('Delete'); }
              })
              .fail(function (xhr) {
                Toast.show((xhr.responseJSON && xhr.responseJSON.error) || 'Request failed', 'error');
                lb.stop('Delete');
              });
          },
        },
      ]).show();
    });
  });

  // ---------- Reset password ----------
  $(document).on('click', '.user-password-btn', function () {
    var id = $(this).closest('tr').data('id');
    $.get('/api/users/modal/password/', { id: id }, function (resp) {
      if (!resp.ok) { Toast.show(resp.error || 'Failed', 'error'); return; }
      var dlg = new Dialog('Reset password', resp.html, { size: 'md' });
      dlg.setButtons([
        { name: 'Cancel', dismiss: true },
        {
          name: 'Set password',
          class: BTN_PRIMARY,
          onClick: function () {
            var lb = new LoadingButton(this); lb.start();
            $.post('/api/users/' + id + '/password/', { password: $('#user-password').val() })
              .done(function (r) {
                if (r.ok) {
                  Toast.show('Password updated', 'success');
                  dlg.hide();
                } else { Toast.show(r.error || 'Failed', 'error'); lb.stop('Set password'); }
              })
              .fail(function (xhr) {
                Toast.show((xhr.responseJSON && xhr.responseJSON.error) || 'Request failed', 'error');
                lb.stop('Set password');
              });
          },
        },
      ]).show();
    });
  });

})(jQuery);
